'use client'

import type { IMetaWrapper, INotification } from '../types'

import { useUpFetch } from '../utils'

export const useNotificationsApi = () => {
  const upFetch = useUpFetch()

  const markAsReadNotifications = async (idsNotification: string[]) =>
    upFetch(`/users/notifications/read`, {
      body: {
        ids: idsNotification,
      },
      method: 'POST',
    })

  const getNotifications = async (paginationData?: string) =>
    upFetch<IMetaWrapper<INotification>>(`/users/notifications?`, {
      params: {
        paginationData,
      },
    })

  return {
    getNotifications,
    markAsReadNotifications,
  }
}
